import { render } from "./SelectPlayer.vue?vue&type=template&id=4d41bfa7&ts=true"
import script from "./SelectPlayer.vue?vue&type=script&lang=ts"
export * from "./SelectPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__